import { Drawer, Typography, styled, Box } from "@mui/material";

export const Styled = {
    Drawer: styled(Drawer)`
        width: 250px;
        & .MuiDrawer-paper {
            width: 250px;
            background-color: #093442;
            color: #fff;
            padding: 15px 0px 0px 15px;
        }
    `,
    Logo: styled("img")`
        width: 60px;
        height: 60px;
        margin: 10px 0px;
    `,
    ListItem: styled("div")`
        margin: 10px 0px;
        color: white;
        opacity: 50%;
        text-decoration: none;
        display: flex;
        align-items: center;
        cursor: pointer;

        &.active {
            color: #fff;
            opacity: 100%;
        }

        &:hover {
            background-color: #174150;
            opacity: 80%;
        }
    `,
    ListItemSkeleton: styled(Box)`
        margin: 10px 0px;
        display: flex;
        align-items: center;
        gap: 10px;
        padding-right: 15px;
    `,
    Subtitle: styled(Typography)`
        opacity: 0.75;
        font-weight: bold;
        padding: 15px 15px 10px;
    `,
};
